import React from 'react';
import { Section, Button, Countdown } from './ui';
import { CheckCircle2, Check } from 'lucide-react';
const CHECKOUT_URL = 'https://sistema-iphone-ads.myshopify.com/cart/add?id=46176935641285&quantity=1&return_to=/cart';
export const TargetAudience = () => {
  const points = ['Querés empezar desde cero y sin stock propio.', 'Tenés poco capital y querés moverte mejor.', 'Querés vender por pedido antes de arriesgar plata.', 'Querés aprender a conseguir clientes por redes.', 'Ya vendés iPhones y querés ordenar tu sistema.'];
  return <Section data-id="element-210">
      <div className="max-w-3xl mx-auto bg-zinc-900/50 backdrop-blur-sm md:backdrop-blur-md border border-white/[0.05] rounded-3xl p-6 md:p-10 shadow-md md:shadow-xl" data-id="element-211">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-212">
          Este curso es para vos si…
        </h2>
        <ul className="space-y-4" data-id="element-213">
          {points.map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-214">
              <CheckCircle2 className="w-6 h-6 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-215" />
              <span className="text-zinc-300 text-lg" data-id="element-216">{item}</span>
            </li>)}
        </ul>
      </div>
    </Section>;
};
export const Offer = () => {
  const includes = ['Curso grabado', 'Acceso inmediato', 'Negocio + marketing', 'Material digital', 'Sin acompañamiento personalizado'];
  return <Section id="oferta" className="bg-white/[0.02] border-y border-white/[0.05] backdrop-blur-sm" data-id="element-217">
      <div className="max-w-4xl mx-auto" data-id="element-218">
        <div className="text-center mb-10" data-id="element-219">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-220">
            Qué incluye el acceso
          </h2>
        </div>

        <div className="bg-zinc-950/80 backdrop-blur-md md:backdrop-blur-xl border-2 border-blue-600/50 rounded-3xl p-6 md:p-12 shadow-[0_0_30px_rgba(37,99,235,0.1)] relative overflow-hidden" data-id="element-221">
          <div className="absolute top-0 right-0 bg-blue-600 text-white text-xs md:text-sm font-bold px-3 md:px-4 py-1 rounded-bl-xl z-20" data-id="element-222">
            OFERTA ESPECIAL
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-223">
            <div className="space-y-8" data-id="element-224">
              <ul className="space-y-4" data-id="element-225">
                {includes.map((item, i) => <li key={i} className="flex items-center space-x-3" data-id="element-226">
                    <Check className="w-6 h-6 text-blue-500 flex-shrink-0" data-id="element-227" />
                    <span className="text-zinc-200 text-lg font-medium" data-id="element-228">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-zinc-900/60 backdrop-blur-sm md:backdrop-blur-md rounded-3xl p-6 md:p-8 text-center border border-white/[0.05] shadow-md md:shadow-xl relative overflow-hidden" data-id="element-229">
              <div className="absolute inset-0 bg-gradient-to-b from-blue-500/5 to-transparent pointer-events-none" data-id="element-230"></div>

              <p className="text-2xl font-bold text-white mb-2" data-id="element-231">
                Accedé hoy con precio especial
              </p>
              <p className="text-zinc-400 text-sm mb-6" data-id="element-232">
                Esta oferta especial está activa durante la cuenta regresiva.
              </p>

              <div className="mb-6" data-id="element-233">
                <Countdown data-id="element-234" />
              </div>

              <Button href={CHECKOUT_URL} className="w-full mb-4 py-5 text-xl shadow-[0_0_30px_rgba(16,185,129,0.15)]" data-id="element-235">
                Acceder ahora por $19.000
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Section>;
};